// extracted by mini-css-extract-plugin
export default {"container":"lu-z","brandName":"mu-z","productName":"nu-z","aboveGalleryInfo":"ou-z","belowGalleryInfo":"pu-z","breakLongProductName":"qu-z"};